export function NotFound() {
  return <main className="flow" data-testid="not-found">
    <a className="wordmark" href="/">WORD &amp; WILL</a>
    <section>
      <p className="eyebrow">404</p>
      <h1>Page not found</h1>
      <p>This address does not match a WORD &amp; WILL page.</p>
      <a className="button" href="/">Return home</a>
    </section>
  </main>;
}
